import { createContext } from 'react';
import { Data } from 'prismic/types';

export const SharedContentContext = createContext({} as Data | null);
export const SharedContentProvider = SharedContentContext.Provider;
export const SharedContentConsumer = SharedContentContext.Consumer;
